export enum UsernameType {
  Email = 'email',
  PhoneNumber = 'phoneNumber',
  Mixed = 'mixed',
  Other = 'other'
}
